import {
	createActionsHook,
	createStateHook,
	createStore,
	type BoundActions,
	type HookActionsFunction,
	type HookStateFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { AudienceSnapshot } from './types';

type State = { byScope: Record<string, AudienceSnapshot> };

const store = createStore({
	initialState: { byScope: {} } as State,
	name: 'RovoTargetingAudienceStore',
	actions: {
		setSnapshot:
			(snapshot: AudienceSnapshot): (({ getState, setState }: StoreActionApi<State>) => void) =>
			({ getState, setState }) =>
				setState({ byScope: { ...getState().byScope, [snapshot.scopeKey]: snapshot } }),
		clearSnapshot:
			(scopeKey: string): (({ getState, setState }: StoreActionApi<State>) => void) =>
			({ getState, setState }) => {
				const { [scopeKey]: _removed, ...byScope } = getState().byScope;
				setState({ byScope });
			},
	},
});

type AudienceActions = {
	setSnapshot: (
		snapshot: AudienceSnapshot,
	) => ({ getState, setState }: StoreActionApi<State>) => void;
	clearSnapshot: (scopeKey: string) => ({ getState, setState }: StoreActionApi<State>) => void;
};

export const useAudienceSnapshots: HookStateFunction<State, void> = createStateHook(store);
export const useAudienceSnapshotActions: HookActionsFunction<BoundActions<State, AudienceActions>> =
	createActionsHook(store);
